// extracted by mini-css-extract-plugin
export default {"new-section":"Curriculum_new-section__gmsrl"};